var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "Meter",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "DIV",
            { staticClass: "page--v2 d-flex flex-column" },
            [
              _c(
                "MaterialTabs",
                { attrs: { tabManager: _vm.tabManager } },
                [
                  _c(
                    "ItpBox",
                    {
                      staticClass: "mr-3",
                      attrs: { slot: "tabs-start", alignItems: "center" },
                      slot: "tabs-start"
                    },
                    [
                      _c(
                        "b-breadcrumb",
                        { staticClass: "m-0 bg-white" },
                        [
                          _c("b-breadcrumb-item", {
                            attrs: {
                              text: _vm._f("gettext")("Meters"),
                              to: _vm.b_2285343489561581_to
                            }
                          }),
                          _vm._v(" "),
                          _c("b-breadcrumb-item", {
                            attrs: {
                              text: _vm.item.snapshot("serial_number"),
                              active: ""
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("ItpButton", {
                        staticClass: "mr-2",
                        attrs: {
                          variant: "light",
                          icon: "fa-sync-alt",
                          tooltip: _vm._f("gettext")("Reload"),
                          spinning: _vm.actions.reload.isRunning,
                          size: "sm"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.evh_2095089031469157_clickPreventStop(
                              $event,
                              {}
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BtnDeleteResource", {
                        staticClass: "mr-2",
                        attrs: { resource: _vm.item, "no-text": "" },
                        on: {
                          success: function($event) {
                            return _vm.evh_9004123373732307_success($event, {})
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("ItpButton", {
                        attrs: {
                          icon: "material-symbols:history",
                          tooltip: _vm._f("pgettext")(
                            "Invoice history",
                            "Invoice"
                          ),
                          size: "sm"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.evh_397195341670858_clickPreventStop(
                              $event,
                              {}
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      staticClass: "container float-left",
                      attrs: { title: _vm._f("gettext")("General") }
                    },
                    [
                      _vm.tabManager.visited(0)
                        ? _c(
                            "ItpRow",
                            [
                              _c(
                                "ItpCol",
                                { attrs: { w: "6" } },
                                [
                                  _c("UcMeterGeneralPanel", {
                                    staticClass: "pb-4",
                                    attrs: {
                                      meter: _vm.item,
                                      reload: _vm.lastLoaded
                                    },
                                    on: {
                                      reload: function($event) {
                                        return _vm.evh_2679161326024595_reload(
                                          $event,
                                          {}
                                        )
                                      },
                                      saved: function($event) {
                                        return _vm.evh_2679161326024595_saved(
                                          $event,
                                          {}
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.item
                                    ? _c("UcRentalServices", {
                                        attrs: {
                                          meter: _vm.item,
                                          reload: _vm.lastLoaded
                                        },
                                        on: {
                                          reload: function($event) {
                                            return _vm.evh_7987652045662005_reload(
                                              $event,
                                              {}
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "ItpCol",
                                { attrs: { w: "6" } },
                                [
                                  _c("UcCommentsList", {
                                    staticClass: "pb-4",
                                    attrs: {
                                      parent: _vm.item,
                                      reload: _vm.lastLoaded
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("UcAttachmentsList", {
                                    staticClass: "pb-4",
                                    attrs: {
                                      parent: _vm.item,
                                      reload: _vm.lastLoaded
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      staticClass: "container-fluid h-100",
                      attrs: { title: _vm._f("pgettext")("Readings", "Meter") }
                    },
                    [
                      _vm.tabManager.visited(1)
                        ? _c("UcMeterReadings", {
                            staticClass: "h-100",
                            attrs: { meter: _vm.item, reload: _vm.lastLoaded }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      staticClass: "container-fluid h-100",
                      attrs: {
                        title: _vm._f("pgettext")("Consumptions", "Meter")
                      },
                      on: {
                        reload: function($event) {
                          return _vm.evh_6806515264385235_reload($event, {})
                        }
                      }
                    },
                    [
                      _vm.tabManager.visited(2)
                        ? _c("UcMeterConsumptions", {
                            staticClass: "h-100",
                            attrs: { meter: _vm.item, reload: _vm.lastLoaded }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      staticClass: "container-fluid h-100",
                      attrs: {
                        title: _vm._f("pgettext")("Auto Readings", "Meter")
                      }
                    },
                    [
                      _vm.tabManager.visited(3)
                        ? _c("UcMeterCharts", {
                            staticClass: "h-100",
                            attrs: { meter: _vm.item, reload: _vm.lastLoaded }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      staticClass: "container-fluid h-100",
                      attrs: { title: _vm._f("pgettext")("Invoices", "Meter") }
                    },
                    [
                      _vm.tabManager.visited(4)
                        ? _c("UcMeterInvoices", {
                            staticClass: "h-100",
                            attrs: { meter: _vm.item, reload: _vm.lastLoaded }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }